export default "__VITE_ASSET__DmeWby6R__"